import React from 'react';

export class Footer extends React.Component {
  render() {
    function twitterScript() {
      return '!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?"http":"https";if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+"://platform.twitter.com/widgets.js";fjs.parentNode.insertBefore(js,fjs);}}(document,"script","twitter-wjs");';
    }

    let resourcesTab = [
      { text: 'Test Resource 010101', href: '' },
      {
        text:
          'Virtual Training: Implementing NAPSG’s Incident Symbology Guideline',
        href: '',
      },
      {
        text:
          'Materials Available from the National Geospatial Preparedness Summit',
        href: '',
      },
      {
        text: 'Virtual Training: How to Use the New Tornado SOG Template',
        href: '',
      },
      { text: 'NAPSG SOGs for download/Word format', href: '' },
    ];

    let news = [
      {
        text:
          'PRESS RELEASE – First Responders Convene for National Summit and Awards on GIS Technology',
        href: '',
      },
      { text: '2016 Sponsorship Opportunities Now Available!', href: '' },
      {
        text: 'Results Released! National Incident Symbology Survey',
        href: '',
      },
      {
        text:
          'Esri public safety demo video: Law enforcement/special events planning',
        href: '',
      },
      {
        text:
          'Registration Open for Inaugural National Geospatial Preparedness Summitt',
        href: '',
      },
    ];

    let supporters = [
      {
        src:
          'https://www.napsgfoundation.org/wp-content/themes/napsg/media/images/logos/mapsforlife.png',
        height: '90',
        width: '82',
      },
      {
        src:
          'https://www.napsgfoundation.org/wp-content/themes/napsg/media/images/logos/microsoft.png',
        height: '42',
        width: '142',
      },
      {
        src:
          'https://www.napsgfoundation.org/wp-content/themes/napsg/media/images/logos/esri.png',
        height: '45',
        width: '127',
      },
      {
        src:
          'https://www.napsgfoundation.org/wp-content/themes/napsg/media/images/logos/csx.png',
        height: '45',
        width: '74',
      },
    ];

    let EmailHtml = () => {
      let html =
        "<b>Did you experience a technical issue with the tool?</b> If so, please send us an email at <a href='mailto:symbol@publicsafetygis.org'>symbol@publicsafetygis.org</a> that describes the technical issue you experienced.";
      return (
        <p className='text-left' dangerouslySetInnerHTML={{ __html: html }}></p>
      );
    };

    return (
      <div className='footer'>
        <div id='supporters' className='wrap'>
          {EmailHtml()}
          <h4>Our Supporters</h4>

          <p>
            <span>
              <img
                src='https://www.napsgfoundation.org/wp-content/themes/napsg/media/images/logos/mapsforlife.png'
                height='90'
                width='82'
              />
            </span>
            <span>
              <img
                src='https://www.napsgfoundation.org/wp-content/themes/napsg/media/images/logos/dewberry.png'
                height='45'
                width='299'
              />
            </span>
            <span>
              <img
                src='https://www.napsgfoundation.org/wp-content/themes/napsg/media/images/logos/esri.png'
                height='45'
                width='127'
              />
            </span>
            <span>
              <img
                src='https://www.napsgfoundation.org/wp-content/themes/napsg/media/images/logos/csx.png'
                height='45'
                width='74'
              />
            </span>
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/main/footer.js